import React                     from 'react';
import classNames                from 'classnames';
import { Observe }               from 'rewire-core';
import { WithStyle }             from 'rewire-ui';
import List                      from '@material-ui/core/List';
import { Theme }                 from '@material-ui/core/styles';
import Typography                from '@material-ui/core/Typography';
import { ISelectableEntity }     from '../DataTypes';
import Loader                    from '../ui/Loader';
import EntityListCardView, {
  IEntityListCardViewProps,
  IItemRendererProps,
}                                from './EntityListCardView';
import EntityListModel           from './EntityListModel';
import { withStyles }            from '../utility/styles';
import PagingView                from '../settings/PagingView';

export const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flexShrink: 0,
  },
  contentRoot: {
    width: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    overflow: 'auto',
    marginRight: '8px',
    flex: '1',
  },
  loaderContainer: {
    width: '100%',
    minHeight: '0px',
    flex: '1',
  },
  list: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    overflow: 'auto',
    transitionProperty: 'opacity',
    transitionDuration: '2s',
  },
  listHasEntities: {
    border: `1px solid ${theme.palette.neutralLight.main}`,
  },
  noResults: {
    fontStyle: 'italic'
  },
  loading: {
    height: '100%',
    cursor: 'wait',
    fontStyle: 'italic',
    margin: '10px',
  },
  pagingRoot: {
    padding: '0px',
    margin: '10px 0px 0px 0px',
    flex: '0 0 auto',
    minHeight: 'auto',
    flexShrink: 0,
  },
});

export type EntityListStyles = ReturnType<typeof styles>;

export interface IEntityListProps {
  model:                 EntityListModel;
  ListHeader?:           React.FunctionComponent<any>;
  ListFooter?:           React.FunctionComponent<any>;
  cardViewRenderer?:     React.ComponentType<IEntityListCardViewProps>;
  cardViewItemRenderer?: React.FunctionComponent<IItemRendererProps>;
  className?:            string;
  classes?:              any;
  cardViewClasses?:      any;
  cardViewItemClasses?:  any;
  hidePaging?:           boolean;
}

export type EntityListProps = WithStyle<EntityListStyles, IEntityListProps>;

class EntityListView extends React.PureComponent<EntityListProps> {
  constructor(props: EntityListProps) {
    super(props);
  }

  get noResults() {
    return <Typography className={this.props.classes.noResults} variant='subtitle1'>No results available</Typography>;
  }

  createCardView = (e: ISelectableEntity) => {
    const key      = e.id;
    const CardView = this.props.cardViewRenderer || EntityListCardView;
    return <CardView key={key} model={this.props.model} entity={e} itemRenderer={this.props.cardViewItemRenderer} classes={this.props.cardViewClasses} itemClasses={this.props.cardViewItemClasses} />;
  };

  render() {
    const { classes, className, model, ListHeader, ListFooter, hidePaging } = this.props;

    return (
      <div className={classNames(classes.root, className)}>
        <div className={classes.contentRoot}>
          <Observe render={() => (
            < >
              {ListHeader && <ListHeader />}
              <Loader loading={model.pagingModel.loading} classes={{root: classes.loaderContainer}}>
                <Observe render={() => {
                  const entities = model.state.entities;
                  return (
                    <List className={classNames(classes.list, entities.length ? classes.listHasEntities : undefined)}>
                      {
                        entities.length
                          ? entities.map(this.createCardView)
                          : this.noResults
                      }
                    </List>
                  );
                }} />
              </Loader>
              {ListFooter && <ListFooter />}
            </>
          )} />
        </div>
        <Observe render={() => (
          !hidePaging && model.pagingModel.count > 0
            ? <PagingView paging={model.pagingModel} className={classes.pagingRoot} />
            : null
          
        )} />

      </div>
    );
  }
}

export default withStyles<IEntityListProps>(styles, EntityListView);
